var _path, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.95 13.2375C25 12.85 24.7125 12.5 24.325 12.5H21.25V11.075C23.175 10.575 24.65 8.975 24.95 6.9875C25 6.6 24.7125 6.25 24.325 6.25H21.25V5C21.25 4.3125 20.6875 3.75 20 3.75H10C9.3125 3.75 8.75 4.3125 8.75 5V6.25H5.675C5.2875 6.25 5 6.6 5.05 6.9875C5.35 8.975 6.825 10.575 8.75 11.075V12.5H5.675C5.2875 12.5 5 12.85 5.05 13.2375C5.35 15.225 6.825 16.825 8.75 17.325V18.75H5.675C5.2875 18.75 5 19.1 5.05 19.4875C5.35 21.475 6.825 23.075 8.75 23.575V25C8.75 25.6875 9.3125 26.25 10 26.25H20C20.6875 26.25 21.25 25.6875 21.25 25V23.575C23.175 23.075 24.65 21.475 24.95 19.4875C25 19.1 24.7125 18.75 24.325 18.75H21.25V17.325C23.175 16.825 24.65 15.225 24.95 13.2375ZM15 23.75C13.6125 23.75 12.5 22.625 12.5 21.25C12.5 19.875 13.6125 18.75 15 18.75C16.375 18.75 17.5 19.875 17.5 21.25C17.5 22.625 16.3875 23.75 15 23.75ZM15 17.5C13.6125 17.5 12.5 16.375 12.5 15C12.5 13.625 13.6125 12.5 15 12.5C16.375 12.5 17.5 13.625 17.5 15C17.5 16.375 16.3875 17.5 15 17.5ZM15 11.25C13.6125 11.25 12.5 10.125 12.5 8.75C12.5 7.3625 13.6125 6.25 15 6.25C16.375 6.25 17.5 7.3625 17.5 8.75C17.5 10.125 16.3875 11.25 15 11.25Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8951,
    cy: 15.1042,
    rx: 2.62238,
    ry: 2.60417,
    fill: "#FF9C1A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8951,
    cy: 21.1458,
    rx: 2.62238,
    ry: 2.60417,
    fill: "#00D68F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8951,
    cy: 8.64579,
    rx: 2.62238,
    ry: 2.60417,
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunction);
export default __webpack_public_path__ + "static/media/junction.f0b4201bcc841a4999cf2b96d2010618.svg";
export { ForwardRef as ReactComponent };